
import { useCallback, useEffect, useRef } from "react";
import { debugLog } from "@/utils/debugLogger";

export const useUndoToast = (
  title: string,
  duration?: number,
  onUndo?: () => void
) => {
  // Use useCallback to memoize the undo handler
  const handleUndo = useCallback(() => {
    debugLog('action', `UndoToast: Undo clicked for "${title}"`);
    onUndo?.();
  }, [onUndo, title]);
  
  // Use ref to track if we've already logged this toast
  const hasLogged = useRef(false);
  
  // Log toast creation only once
  useEffect(() => {
    if (!hasLogged.current) {
      debugLog('important', `UndoToast: Created with title "${title}"`);
      hasLogged.current = true;
    }
    
    return () => {
      hasLogged.current = false;
    };
  }, [title]);
  
  return {
    handleUndo
  };
};
